import { JSON } from '../utils/types'

export default class FraudProtectionToken {
  token: string

  constructor(data: JSON = {}) {
    this.token = data.fraud_protection_token
  }
}
